import React from 'react';
import { FadeIn } from './Shared';
import { Scale } from 'lucide-react';
export const CostComparison = () => {
  return <section className="py-16 md:py-24 px-4 bg-navy-900/30 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-46">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-47">
        <FadeIn data-id="element-48">
          <div className="text-center mb-16" data-id="element-49">
            <div className="inline-flex items-center justify-center bg-orange-500/10 px-4 py-2 rounded-full border border-orange-500/20 mb-6" data-id="element-50">
              <Scale className="w-6 h-6 text-orange-400 mr-3" data-id="element-51" />
              <span className="text-orange-400 font-bold tracking-[0.2em] text-xs uppercase" data-id="element-52">
                LA BALANZA
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl text-white mb-6 leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-53">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>

          <div className="bg-navy-950 rounded-3xl border border-white/10 overflow-hidden" data-id="element-54">
            <div className="overflow-x-auto" data-id="element-55">
              <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-56">
                <thead data-id="element-57">
                  <tr className="bg-navy-900 border-b border-white/10" data-id="element-58">
                    <th className="py-6 md:py-8 px-6 md:px-8 text-red-400 font-bold text-xs md:text-sm uppercase tracking-widest w-1/2 border-r border-white/5" data-id="element-59">
                      Sin Método Silencio Total
                    </th>
                    <th className="py-6 md:py-8 px-6 md:px-8 text-orange-400 font-bold text-xs md:text-sm uppercase tracking-widest w-1/2" data-id="element-60">
                      Costo real
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-white/5" data-id="element-61">
                  {[['Cada ladrido sin sistema', 'Culpa acumulada + relación con el edificio desgastada'], ['Volver porque lloraba esta semana', 'Le enseñaste exactamente que llorar funciona'], ['Ceder por vergüenza social', 'Reforzaste el comportamiento que más querés eliminar'], ['No saber si lo que hacés ayuda', 'Improvisación que casi siempre escala el problema'], ['La nota del consorcio que no sabés cómo responder', 'Conflicto edilicio sin herramientas para manejarlo'], ['El domingo angustiado por la semana que viene', 'El mismo ciclo el próximo lunes']].map(([sin, costo], i) => <tr key={i} className="transition-colors hover:bg-white/[0.02]" data-id="element-62">
                      <td className="py-5 md:py-6 px-6 md:px-8 text-gray-300 border-r border-white/5 font-medium font-sans text-sm md:text-base leading-relaxed" data-id="element-63">
                        {sin}
                      </td>
                      <td className="py-5 md:py-6 px-6 md:px-8 text-gray-100 font-sans font-medium text-base md:text-lg leading-relaxed" data-id="element-64">
                        {costo}
                      </td>
                    </tr>)}
                </tbody>
                <tfoot data-id="element-65">
                  <tr className="bg-navy-900/80 border-t-2 border-orange-500/30" data-id="element-66">
                    <td colSpan={2} className="py-10 md:py-12 px-6 md:px-8 text-center" data-id="element-67">
                      <span className="text-xl md:text-4xl font-bold text-white leading-tight font-[Montserrat,_sans-serif]" data-id="element-68">
                        La próxima vez que cerrés la puerta{' '}
                        <span className="text-orange-400" data-id="element-69">
                          puede haber silencio del otro lado.
                        </span>
                      </span>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};